// components/StreamModal.jsx
import React from "react";

// Helper: Convert to embeddable YouTube URL with autoplay
const getYouTubeEmbedUrl = (url) => {
  const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^\s&]+)/i);
  if (!match) return null;

  const videoId = match[1];
  return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1`; // mute=1 is often needed for autoplay to work in browsers
};

const StreamModal = ({ url, onClose }) => {
  if (!url) return null;

  const embedUrl = getYouTubeEmbedUrl(url);
  if (!embedUrl) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center">
      <div className="relative w-full max-w-4xl aspect-video">
        <iframe
          src={embedUrl}
          className="w-full h-full rounded-lg"
          title="Launch Stream"
          allow="autoplay; encrypted-media; picture-in-picture"
          allowFullScreen
          frameBorder="0"
        />
        <button
          onClick={onClose}
          className="absolute top-2 right-2 bg-white text-black px-3 py-1 rounded shadow"
        >
          ✕ Close
        </button>
      </div>
    </div>
  );
};

export default StreamModal;
